import { FileText, Shield, Zap, DollarSign, Clock, Users } from 'lucide-react';
import styles from './styles.module.css';

const FEATURES = [
    { icon: <FileText />, title: 'Criação Rápida', desc: 'Crie notas orçamentos em segundos com formulário intuitivo e cálculos automáticos.', color: 'indigo' },
    { icon: <Shield />, title: '100% Seguro', desc: 'Dados protegidos com criptografia de ponta e backup automático na nuvem.', color: 'green' },
    { icon: <Zap />, title: 'Automação', desc: 'Cálculo automático de impostos, numeração sequencial e controle de plano.', color: 'purple' },
    { icon: <DollarSign />, title: 'Controle Financeiro', desc: 'Acompanhe recebimentos, status de pagamento e relatórios detalhados.', color: 'orange' },
    { icon: <Clock />, title: 'Histórico Completo', desc: 'Histórico de notas emitidas com busca avançada e filtros por mês e ano.', color: 'blue' },
    { icon: <Users />, title: 'Multi-Cliente', desc: 'Gerencie múltiplos clientes com dados salvos para agilizar futuras emissões.', color: 'pink' },
];

function FeaturesSection(){
    return (
        <section id="features" className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h2 className={styles.sectionTitle}>Tudo que você precisa em um só lugar</h2>
                    <p className={styles.sectionSub}>Recursos poderosos para simplificar sua gestão fiscal</p>
                </div>
                <div className={styles.featuresGrid}>
                    {FEATURES.map((f, i) => (
                        <div key={i} className={`${styles.featureCard} ${styles[`fc_${f.color}`]}`}>
                            <div className={styles.featureIcon}>{f.icon}</div>
                            <h3 className={styles.featureTitle}>{f.title}</h3>
                            <p className={styles.featureDesc}>{f.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
    );
}

export default FeaturesSection;